import { render, staticRenderFns } from "./twitter-order.vue?vue&type=template&id=79d7d980&"
import script from "./twitter-order.vue?vue&type=script&lang=js&"
export * from "./twitter-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports